export default __webpack_public_path__ + "static/media/icon-alert-info-warning.c3781a2b.svg";